const yellow = {
  head: {
    style: {
      filter: "drop-shadow(0 4px 8px #FED886)",
      fontSize: "16px",
      fontWeight: 500,
      color: "#fff",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#FBBD34",
      paddingBlock: '0.5rem',
      div: {
        whiteSpace: "normal",
        overflow: "visible",
      },
    },
  },
  cells: {
    style: {
      paddingBlock: '0.5rem',
    },
  },
};

const gray = {
  headRow: {
    style: {
      backgroundColor: "#F2F2F2",
      fontSize: "15px",
      fontWeight: 600,
      border: "none",
    },
  },
  headCells: {
    style: {
      div: {
        whiteSpace: "normal",
        overflow: "visible",
      },
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      fontWeight: 400,
      "&:nth-of-type(odd)": {
        backgroundColor: "#FFFFFF",
        border: "none",
      },
      "&:nth-of-type(even)": {
        backgroundColor: "#F8F8F8",
        border: "none",
      },
    },
  },
  cells: {
    style: {
      paddingBlock: "6px",
      div: {
        whiteSpace: "normal !important",
        overflow: "visible !important",
      },
    },
  },
};

const grayShadow = {
  headRow: {
    style: {
      backgroundColor: "#9B9B9B",
      filter: "drop-shadow(0 4px 8px rgba(155, 155, 155, 0.5))",
      fontSize: "16px",
      fontWeight: 600,
      color: "#ffffff",
    },
  },
  headCells: {
    style: {
      div: {
        whiteSpace: "normal",
        overflow: "visible",
      },
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      fontWeight: 400,
    },
  },
  cells: {
    style: {
      paddingBlock: "6px",
    },
  },
};

export const customStyles = {
  yellow,
  gray,
  grayShadow,
};